<template>
  <div>
    <div class="row mt-3 border border-3">
      <!-- !!!: sync with example from step 3 in building wizard (2021.10.20) -->
      <div class="col">
        Le nombre de voix seront réduit
        <span v-if="generalDetails.plafonMajorityText">pour la raison suivant</span> :
        <div>
          <br />
          <!-- eslint-disable vue/no-v-html -->
          <p
            v-if="generalDetails.plafonMajorityText"
            v-html="showBr(generalDetails.plafonMajorityText)"
          />
        </div>
        <ul>
          <li v-for="bo of generalDetails.buildingOwnersWithReducedTantiemes" :key="bo.id">
            {{ getPersonName({ personId: bo.id }) }} dispose de
            {{ bo.reducedMandateTantiemesChargeGenerale }} voix au lieu de
            {{ bo.totalMandateTantiemesChargeGenerale }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["generalDetails"],
};
</script>
